var map = {
	"./basic.svg": 95,
	"./basic_bw.svg": 14,
	"./basic_name.svg": 15,
	"./io.svg": 96,
	"./io_bw.svg": 16,
	"./io_name.svg": 17,
	"./simquadrat.svg": 97,
	"./simquadrat_bw.svg": 5,
	"./simquadrat_name.svg": 18,
	"./sipgate.svg": 98,
	"./sipgate_bw.svg": 19,
	"./sipgate_name.svg": 20,
	"./team.svg": 99,
	"./team_bw.svg": 21,
	"./team_name.svg": 22,
	"./trunking.svg": 100,
	"./trunking_bw.svg": 23,
	"./trunking_name.svg": 24
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6;


//////////////////
// WEBPACK FOOTER
// ./src/assets/patterns ^\.\/.*\.svg$
// module id = 6
// module chunks = 0